import type { LiquidSubEntry } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  ActivityType,
  LiquidUnit,
} from "@tandemdiabetes/sugarmate-api-react-client"
import { useMemo } from "react"
import {
  useAccountProperty,
  useFindUserEntries,
} from "src/hooks"
import { createEntryQueryObjectForType } from "src/utils"

/*
 * returns the units from the most recent liquid activity
 */
export function useDefaultLiquidUnit(): LiquidUnit {
  const accountId = useAccountProperty(
    "id",
    NaN,
  )

  const lastLiquidEntrySelector = useMemo(
    () => createEntryQueryObjectForType(
      accountId,
      ActivityType.Liquid,
      {
        sort: [{ started_at: "desc" as const }],
        limit: 1,
      },
    ),
    [accountId],
  )

  const { result } = useFindUserEntries(lastLiquidEntrySelector)

  return useMemo(
    () => {
      const mostRecentLiquidSubEntry = result[0]?.subentries.find(
        (subEntry) => subEntry.subentry_type === ActivityType.Liquid,
      ) as LiquidSubEntry | undefined

      return mostRecentLiquidSubEntry?.liquid.units ?? LiquidUnit.Milliliters
    },
    [result],
  )
}
